@if (numeroImagenes > 0) {
  <div (touchstart)="swipe($event, 'start')" (touchend)="swipe($event, 'end')" [ngClass]="{ visible: show === true }" (click)="cerrarClickFuera($event)" class="fullScreenContainer">
    @if (isImg) {
      <div class="imgContainer">
        <ng-container>
          <img [src]="imgSeleccionada()" [ngClass]="{ 'fade-in': fade(), 'fade-out': !fade() }" alt="imagen" draggable="false" />
        </ng-container>
      </div>
    }

    @if (numeroImagenes > 1) {
      <app-galeria-slider></app-galeria-slider>
    }

    <button mat-icon-button class="close-button" (click)="cerrarViewer()">
      <mat-icon aria-hidden="false" aria-label="Cerrar imagen">close</mat-icon>
    </button>

    @if (numeroImagenes > 1) {
      <div class="arrow-container previous" (click)="anterior()">
        <mat-icon class="arrowicon arrow">chevron_left</mat-icon>
      </div>
    }
    @if (numeroImagenes > 1) {
      <div class="arrow-container next" (click)="siguiente()">
        <mat-icon class="arrowicon arrow">chevron_right</mat-icon>
      </div>
    }
  </div>
}
